import { Component, DestroyRef, OnInit } from '@angular/core';
import { API, Pagination, SSPContractDTO, SSPDTO } from '../../services/api/api';
import { ModalNavigationService } from '../../services/gui/modal/modal-navigation.service';
import { UtilService } from '../../services/util.service';
import { BehaviorSubject } from 'rxjs';
import { ErrorService } from '../../services/error.service';
import { ModalNavigationComponent } from '../../services/gui/modal/modal-navigation-component';
import { PermissionService } from '../../services/permission.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { take } from 'rxjs/operators';

@Component({
  selector: 'sb-comp-sspContract-creation',
  templateUrl: './sspContract-creation.component.html',
  styleUrls: ['./sspContract-creation.component.scss'],
  standalone: false,
})
export class SSPContractCreationComponent implements OnInit, ModalNavigationComponent {
  isInModalContext: boolean;
  sspContract: SSPContractDTO;
  SSPs: SSPDTO[];
  paginationSSPs: BehaviorSubject<Pagination>;
  ssp: SSPDTO;
  identifier: string;
  name: string;
  editMode: boolean;
  suffix: string;
  prefix: string;

  constructor(
    private api: API,
    private modalNavigation: ModalNavigationService,
    public util: UtilService,
    private errorHandler: ErrorService,
    public permissionService: PermissionService,
    private destroyRef: DestroyRef
  ) {
    this.name = '';
    this.prefix = '';
    this.suffix = '';
    this.editMode = false;
    this.sspContract = undefined;
    this.SSPs = undefined;
    this.ssp = undefined;
    this.identifier = '';
    this.paginationSSPs = new BehaviorSubject<Pagination>({ page: 1, count: 99, pages: -1, resultcount: -1 });
  }

  ngOnInit(): void {
    this.api
      .shared_SSP_retrieveAll({}, this.paginationSSPs)
      .pipe(takeUntilDestroyed(this.destroyRef), take(1))
      .subscribe({
        next: (receivedSSPs: SSPDTO[]) => {
          this.SSPs = receivedSSPs;
        },
        error: error => {
          this.errorHandler.errorHandler(error);
        },
      });
    if (this.modalNavigation.getCurrentNavigation().data) {
      const modalData = this.modalNavigation.getCurrentNavigation().data;
      if (modalData.useParamData) {
        if (modalData.editMode) {
          this.sspContract = modalData.sspContract;
          this.identifier = modalData.sspContract.identifier;
          this.name = modalData.sspContract.name;
          this.ssp = modalData.sspContract.ssp;
          this.prefix = modalData.sspContract.screenIdPrefix;
          this.suffix = modalData.sspContract.screenIdSuffix;
          this.editMode = true;
        } else {
          this.sspContract = modalData.sspContract;
          this.editMode = false;
        }
      }
    }
  }

  onIdentifier($event: string) {
    if ($event?.length > 0) {
      this.identifier = $event;
    } else {
      this.identifier = null;
    }
  }

  onName($event: string) {
    if ($event?.length > 0) {
      this.name = $event;
    } else {
      this.name = null;
    }
  }

  getSSPText(): string {
    if (this.ssp) {
      return this.ssp.name;
    }
    return 'n. def.';
  }

  setSSP(ssp: SSPDTO) {
    this.ssp = ssp;
  }

  ok() {
    if (!this.editMode) {
      this.sspContract = new SSPContractDTO();
      this.sspContract.ssp = this.ssp;
      this.sspContract.identifier = this.identifier;
      this.sspContract.name = this.name;
      this.sspContract.screenIdSuffix = this.suffix;
      this.sspContract.screenIdPrefix = this.prefix;
      this.api
        .shared_SSPContract_createSSPContract(this.sspContract)
        .pipe(takeUntilDestroyed(this.destroyRef), take(1))
        .subscribe({
          next: (receivedContract: SSPContractDTO) => {
            this.close(receivedContract);
          },
          error: error => {
            this.errorHandler.errorHandler(error);
          },
        });
    } else {
      this.sspContract.name = this.name;
      this.sspContract.identifier = this.identifier;
      this.sspContract.screenIdSuffix = this.suffix;
      this.sspContract.screenIdPrefix = this.prefix;
      this.api
        .shared_SSPContract_editSSPContract(this.sspContract)
        .pipe(takeUntilDestroyed(this.destroyRef), take(1))
        .subscribe({
          next: (receivedContract: SSPContractDTO) => {
            this.close(receivedContract);
          },
          error: error => {
            this.errorHandler.errorHandler(error);
          },
        });
    }
  }

  close(data: SSPContractDTO) {
    this.modalNavigation.result(data);
  }

  cancel() {
    this.close(null);
  }

  onSuffix($event: string) {
    this.suffix = $event;
  }

  onPrefix($event: string) {
    this.prefix = $event;
  }
}
